var map = {
	"./1-0.png": 1305,
	"./1-1.png": 1306,
	"./1-2.png": 1307,
	"./1-3.png": 1308,
	"./1-4.png": 1309,
	"./1-5.png": 1310,
	"./2-0-aftersale-fast.png": 1311,
	"./2-0-order.png": 1312,
	"./2-1-search.png": 1313,
	"./2-2-普通仅退款.png": 1314,
	"./2-3-普通换货.png": 1315,
	"./2-4-普通补发.png": 1316,
	"./2-5-普通维修.png": 1317,
	"./2-6-普通拒收退货.png": 1318,
	"./2-7-错发退货退款.png": 1319,
	"./2-8-错发仅退款.png": 1320,
	"./2-9-错发换货.png": 1321,
	"./3-1-create-aftersale-empty.png": 1322,
	"./3-2-create-aftersale-return.png": 1323,
	"./3-3-create-aftersale-refund.png": 1324,
	"./3-4-create-aftersale-resend.png": 1325,
	"./3-5-aftersale-detail.png": 1326,
	"./3-6-create-noinfo-aftersale.png": 1327,
	"./3-7-select-noinfo-goods.png": 1328,
	"./3-aftersale-issue-registration.png": 1329,
	"./3-leak-resend-selected.png": 1330,
	"./3-leak-resend.png": 1331,
	"./3-noinfo-aftersale.png": 1332,
	"./3-noinfo-product-library.png": 1333,
	"./3-normal-return.png": 1334,
	"./3-product-library-search-result.png": 1335,
	"./3-product-library.png": 1336,
	"./3-select-exchange-order-goods.png": 1337,
	"./3-select-return-order-goods.png": 1338,
	"./3-wrong-exchange.png": 1339,
	"./4-1-order-query-result.png": 1340,
	"./4-2-aftersale-query.png": 1341,
	"./4-3-aftersale-query-result.png": 1342,
	"./jst_login.png": 1343,
	"./order-default-necklace.png": 1344,
	"./ppt/2-10-普通退货退款建单.png": 1345,
	"./ppt/2-11-普通补发建单.png": 1346,
	"./ppt/2-12-普通补发填写.png": 1347,
	"./ppt/2-13-普通维修建单.png": 1348,
	"./ppt/2-14-错发退货退款建单.png": 1349,
	"./ppt/2-15-错发退货退款问题类型.png": 1350,
	"./ppt/2-16-错发退货退款问题选择.png": 1351,
	"./ppt/2-17-错发退货退款商品库.png": 1352,
	"./ppt/2-18-漏发补发问题类型.png": 1353,
	"./ppt/2-18-错发退货退款添加商品.png": 1354,
	"./ppt/2-19-错发退货退款完成.png": 1355,
	"./ppt/2-20-错发换货建单.png": 1356,
	"./ppt/2-21-漏发补发建单.png": 1357,
	"./ppt/2-22-已创建手工售后单.png": 1358,
	"./ppt/2-22-漏发仅退款建单.png": 1359,
	"./ppt/2-34-错发换货选择订单商品.png": 1360
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan ^\.\/.*$
// module id = 303
// module chunks = 0